var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "experts-area" }, [
    _c("h4", { staticClass: "grey-title" }, [_vm._v("Meet our Experts")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-between" },
      _vm._l(_vm.experts, function(i, k) {
        return _c(
          "article",
          {
            key: k,
            staticStyle: {
              display: "flex",
              "flex-wrap": "wrap",
              "row-gap": "20px"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "name-title",
                staticStyle: { "flex-basis": "100%" }
              },
              [
                _c("h5", [_vm._v(_vm._s(i.title))]),
                _vm._v(" "),
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(i.data.position))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "image small",
                staticStyle: { "flex-basis": "35%" }
              },
              [_c("img", { attrs: { src: i.imagePath, alt: i.title } })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text small",
                staticStyle: { "flex-basis": "50%" }
              },
              [
                i.data.link
                  ? _c(
                      "a",
                      {
                        staticClass: "button blue-border small book-now",
                        attrs: { href: i.data.link }
                      },
                      [_vm._v("Book Now")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "button blue-border small",
                    on: {
                      click: function($event) {
                        return _vm.viewBio(i)
                      }
                    }
                  },
                  [_vm._v("Read Bio")]
                )
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.isOpen
      ? _c("div", { staticClass: "popup-module modal" }, [
          _c("div", {
            staticClass: "modal-background",
            on: {
              click: function($event) {
                return _vm.viewBio(null)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "span",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.viewBio(null)
                  }
                }
              },
              [_c("img", { attrs: { src: "/images/icons/close.svg" } })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex-container" }, [
              _c("div", { staticClass: "image" }, [
                _c("a", { attrs: { href: _vm.getUrl(_vm.openPerson.title) } }, [
                  _c("img", {
                    staticClass: "popup-img",
                    attrs: {
                      src: _vm.openPerson.imageHeroPath,
                      alt: "Habit Health:" + _vm.openPerson.title
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "info" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.openPerson.title))]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.openPerson.data.position))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "button",
                      attrs: { href: _vm.openPerson.data.link }
                    },
                    [_vm._v("Book Now")]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "wysiwyg",
                  domProps: { innerHTML: _vm._s(_vm.openPerson.data.content) }
                })
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37129a8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37129a8a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/LocationExpert.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-37129a8a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/LocationExpert.vue
// module chunks = 0